<!-- 话题的列表项 -->
<template>
<div class="item">
    
    <div class="container">
        <div class="title"><a :href="detailURL|hostBuild('news')" target="_blank">{{title}}</a></div>
        <div class="imgs" v-if="coverImage.length >1">
            <div class="lit" v-for="item in coverImage" :key="item">
                <YorkbbsImage :link="detailURL|hostBuild('news')" :src="item|webpFormat(750)" aspect animation borderRadius="4px" target="_blank"   />
            </div>
        </div>
        <div class="subf-info">
            <div>{{topic.name}}</div>
            <div>{{data.createdAt|timeToStr}}</div>
        </div>
    </div>
    <div class="cover" v-if="coverImage.length==1">
        
        <YorkbbsImage class="sign-img-border" :link="detailURL|hostBuild('news')" :src="coverImage[0]|webpFormat(750)" aspect animation borderRadius="4px" target="_blank"   />
    </div>
</div>    
</template>
<script>
export default {
    name:'SubjectCmsItem',
    props:{data:Object},
    computed:{
        operType(){
            return this.data.operType;
        },
        title(){
            return this.data.title;
        },
        // 人工置顶地址
        url() {
            return this.data.url;
        },
        // 发布时间
        publishTime() {
            return this.data.property.publishTime;
        },
        coverImage() {
            /* let imgArr = [];
            if( this.data.property.coverImage && this.data.property.coverImage.length >0 ){
                imgArr = this.data.property.coverImage;
            }else{
                let maxLg = this.data.imageList.length <3 ? this.data.imageList.length:3;
                imgArr = this.data.imageList.slice(0,maxLg);
            }
            return imgArr; */
            return this.data.imageList.length>4?this.data.imageList.splice(0,4):this.data.imageList;
        },
        imageList() {
            return this.data.imageList || [];
        },
    
        // 版块列表
        topics() {
            return this.data.property.topic || [];
        },
        // 新闻所属版块
        topic() {
            const $topic = this.$route.params.topic;
            const topic = this.topics.find(t => t.englishName === $topic);
            return topic ? topic : this.topics[0];
        },
        // 是否置顶
        isTop() {
            return this.data.property.top == 1;
        },
        // cmsTYpe 信息类型，1 普通新闻 2 新闻专题；3 生活专题；4自定义专题
        cmsType() {
            return this.data.property.cmsType;
        },
        // 生活专题类型，1 大专题；2 小专题
        topicType() {
            return this.data.property.topicType;
        },
        isSpecial() {
            return [2, 3, 4].includes(this.cmsType);
        },
        // 详情页地址
        detailURL() {
            if (this.data.property.jumpLink) {
                return this.data.property.jumpLink;
            } else if (this.cmsType === 3) {
                return hostBuild(`/special/${this.topicType == 1 ? 'big' : 'small'}/${this.data.id}`, 'info');
            } else if ([2, 4].includes(this.cmsType)) {
                return `/feature/${this.topic.englishName}/${this.data.id}`;
            }

            return `/detail/${this.topic.englishName}/${this.data.id}`;
        },
    },
    data(){
        return {

        }
    },
    
}
</script>
<style lang="scss" scoped>
.item{
    margin-bottom: 15px; padding-bottom: 15px; border-bottom: 1px solid #eee; display: flex;
    .cover{width:25%;  margin-right: 10px;}
    .container{
        flex:1;overflow:hidden;
        .title{
            padding-bottom: 10px;
            a{
                font-size: 18px; line-height: 30px;
                &:hover{color: #e43a3a;}
            }
        }
    }
    .imgs{
        display: flex; margin: 0 -5px 0; flex-wrap: wrap;
        .lit{
            width:25%; padding: 0 5px; box-sizing: border-box; margin-bottom: 10px;
        }
        &.alone{
            .lit{width:80%;}
        }
        &.double{
            .lit{width:50%}
        }
    }
    .subf-info{
        display: flex; align-items: center;
        padding-top: 10px;  font-size: 12px; line-height: 20px; color: #999;
        div{
            margin-right: 20px;
        }
    }

    &.single{
        display: flex; align-items: stretch;
        .container{
            flex:1;overflow: hidden; display: flex; flex-direction: column; justify-content:space-between;
        }
    }
    .sign-img-border{
        ::v-deep{
            .el-image{border:1px solid #eee;  box-sizing: border-box;}
        }
    }
}
</style>